"use client"

import React, { useEffect } from "react"
import { CommandPaletteProvider, useCommandPaletteContext } from "@/contexts/command-palette-context"

import { useGlobalCommandActions } from "@/hooks/use-global-command-actions"

export function CommandPaletteWrapper({ children }: { children: React.ReactNode }) {
  return <CommandPaletteProvider>{children}</CommandPaletteProvider>
}

export function CommandPaletteGlobalActionsInitializer() {
  const globalActions = useGlobalCommandActions()
  const { setGlobalActions } = useCommandPaletteContext()

  useEffect(() => {
    setGlobalActions(globalActions)
  }, [globalActions, setGlobalActions])

  return null
}
